import { ConditionControlEnum } from "@/views/loyalty/models/condtion.model"

export default class ConditionItem {
    constructor () {
        // this.comparisonOpShow = false
        this.condtionComparisonOpList = []
        this.control = ConditionControlEnum.textField
        this.feature = ""
        this.postButtonShow = false
        this.url = ""
        this.widthCol = 0
    }

    conditionComparisonOpList () {
        // let result = [];
        switch (this.feature) {
            case "full":
                // this.comparisonOpShow = true
                this.widthCol = 4
                this.condtionComparisonOpList = [
                    { text: "Равно  =", value: "==" },
                    { text: "Больше или Равно  >=", value: ">=" },
                    { text: "Меньше или Равно  <=", value: "<=" },
                    { text: "Больше  >", value: ">" },
                    { text: "Меньше  <", value: "<" },
                    { text: "Не равно  <>", value: "!=" },
                ]
                break

            case "middle":
                // this.comparisonOpShow = true
                this.widthCol = 4
                this.condtionComparisonOpList = [
                    { text: "Равно  =", value: "==" },
                    { text: "Не равно  <>", value: "!=" },
                ]
                break
            case "weak":
                this.widthCol = 5
                // this.comparisonOpShow = false
                this.condtionComparisonOpList = [{ text: "Равно  =", value: "==" }]
                break
        }
        // console.log("result=" + JSON.stringify(result));
        // this.condtionComparisonOpList = result
        return this
    }

    getConditionItems () {
        return {
            // comparisonOpShow: this.comparisonOpShow,
            conditionComparisonOpList: this.condtionComparisonOpList,
            control: this.control,
            postButtonShow: this.postButtonShow,
            url: this.url,
            widthCol: this.widthCol,
        }
    }

    getFeature (value, attributeObj) {
        if (attributeObj === undefined) {
            this._getFeatureBuiltin(value)
        } else {
            this._getFeatureCustom(attributeObj.type)
        }
        return this
    }

    _getFeatureBuiltin (value) {
        switch (value) {
            case "registration":
                this.control = ConditionControlEnum.checkBox
                this.feature = "weak"
                break
            // case "birthday":
            case "fixed_date":
                this.control = ConditionControlEnum.textDateField
                this.feature = "middle"
                break
            case "count_payments":
            case "product_code":
                this.control = ConditionControlEnum.textField
                this.feature = "middle"
                break
            case "amount":
                this.control = ConditionControlEnum.textField
                this.feature = "full"
                break
            default:
                this.control = ConditionControlEnum.textField
                this.feature = "full"
        }
    }

    _getFeatureCustom (value) {
        switch (value) {
            case 0:
                this.control = ConditionControlEnum.textField
                this.feature = "middle"
                break
            case 1:case 3:
                this.control = ConditionControlEnum.textField
                this.feature = "full"
                break
            case 2:
                this.control = ConditionControlEnum.checkBox
                this.feature = "weak"
                break
            case 5:
                this.control = ConditionControlEnum.list
                this.feature = "middle"
                break
        }
    }

    getUrl (value) {
        switch (value) {
            case "product_code":
                this.postButtonShow = true
                this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/nomenclature/list/"`
                break
            case "point":
                this.postButtonShow = true
                this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/point/list/`
                break
            default:
                this.postButtonShow = false
                this.url = ""
        }
        return this
    }
}
